import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import transNavEn from './translations/en/nav.json'
import transNavDe from './translations/de/nav.json'
import transGlobalEn from './translations/en/global.json'
import transGlobalDe from './translations/de/global.json'
import settingsDe from './translations/de/settings.json'
import settingsEn from './translations/en/settings.json'
import individualizationDe from './translations/de/individualization.json'
import individualizationEn from './translations/en/individualization.json'
import customizerDe from './translations/de/customizer.json'
import customizerEn from './translations/en/customizer.json'
import ordersDe from './translations/de/orders.json'
import ordersEn from './translations/en/orders.json'
import commonDe from './translations/de/common.json'
import commonEn from './translations/en/common.json'
import transNavIt from './translations/it/nav.json'
import transGlobalIt from './translations/it/global.json'
import settingsIt from './translations/it/settings.json'
import individualizationIt from './translations/it/individualization.json'
import customizerIt from './translations/it/customizer.json'
import ordersIt from './translations/it/orders.json'
import commonIt from './translations/it/common.json'
import transNavPl from './translations/pl/nav.json'
import transGlobalPl from './translations/pl/global.json'
import settingsPl from './translations/pl/settings.json'
import individualizationPl from './translations/pl/individualization.json'
import customizerPl from './translations/pl/customizer.json'
import ordersPl from './translations/pl/orders.json'
import commonPl from './translations/pl/common.json'
import transNavEs from './translations/es/nav.json'
import transGlobalEs from './translations/es/global.json'
import settingsEs from './translations/es/settings.json'
import individualizationEs from './translations/es/individualization.json'
import customizerEs from './translations/es/customizer.json'
import ordersEs from './translations/es/orders.json'
import commonEs from './translations/es/common.json'
import transNavPt from './translations/pt/nav.json'
import transGlobalPt from './translations/pt/global.json'
import settingsPt from './translations/pt/settings.json'
import individualizationPt from './translations/pt/individualization.json'
import customizerPt from './translations/pt/customizer.json'
import ordersPt from './translations/pt/orders.json'
import commonPt from './translations/pt/common.json'
import transNavCs from './translations/cs/nav.json'
import transGlobalCs from './translations/cs/global.json'
import settingsCs from './translations/cs/settings.json'
import individualizationCs from './translations/cs/individualization.json'
import customizerCs from './translations/cs/customizer.json'
import ordersCs from './translations/cs/orders.json'
import commonCs from './translations/cs/common.json'
import transNavFr from './translations/fr/nav.json'
import transGlobalFr from './translations/fr/global.json'
import settingsFr from './translations/fr/settings.json'
import individualizationFr from './translations/fr/individualization.json'
import customizerFr from './translations/fr/customizer.json'
import ordersFr from './translations/fr/orders.json'
import commonFr from './translations/fr/common.json'
import transNavNl from './translations/nl/nav.json'
import transGlobalNl from './translations/nl/global.json'
import settingsNl from './translations/nl/settings.json'
import individualizationNl from './translations/nl/individualization.json'
import customizerNl from './translations/nl/customizer.json'
import ordersNl from './translations/nl/orders.json'
import commonNl from './translations/nl/common.json'
import loginDe from './translations/de/login.json'
import fulfillmentDe from './translations/de/fulfillment.json'
import fulfillmentEn from './translations/en/fulfillment.json'
import fulfillmentIt from './translations/it/fulfillment.json'
import fulfillmentPl from './translations/pl/fulfillment.json'
import fulfillmentEs from './translations/es/fulfillment.json'
import fulfillmentPt from './translations/pt/fulfillment.json'
import fulfillmentCs from './translations/cs/fulfillment.json'
import fulfillmentFr from './translations/fr/fulfillment.json'
import fulfillmentNl from './translations/nl/fulfillment.json'

const resources = {
    en: {
        common: commonEn,
        nav: transNavEn,
        global: transGlobalEn,
        settings: settingsEn,
        individualization: individualizationEn,
        customizer: customizerEn,
        orders: ordersEn,
        fulfillment: fulfillmentEn,
    },
    de: {
        login: loginDe,
        common: commonDe,
        nav: transNavDe,
        global: transGlobalDe,
        settings: settingsDe,
        individualization: individualizationDe,
        customizer: customizerDe,
        orders: ordersDe,
        fulfillment: fulfillmentDe,
    },
    it: {
        common: commonIt,
        nav: transNavIt,
        global: transGlobalIt,
        settings: settingsIt,
        individualization: individualizationIt,
        customizer: customizerIt,
        orders: ordersIt,
        fulfillment: fulfillmentIt,
    },
    pl: {
        common: commonPl,
        nav: transNavPl,
        global: transGlobalPl,
        settings: settingsPl,
        individualization: individualizationPl,
        customizer: customizerPl,
        orders: ordersPl,
        fulfillment: fulfillmentPl,
    },
    es: {
        common: commonEs,
        nav: transNavEs,
        global: transGlobalEs,
        settings: settingsEs,
        individualization: individualizationEs,
        customizer: customizerEs,
        orders: ordersEs,
        fulfillment: fulfillmentEs,
    },
    pt: {
        common: commonPt,
        nav: transNavPt,
        global: transGlobalPt,
        settings: settingsPt,
        individualization: individualizationPt,
        customizer: customizerPt,
        orders: ordersPt,
        fulfillment: fulfillmentPt,
    },
    cs: {
        common: commonCs,
        nav: transNavCs,
        global: transGlobalCs,
        settings: settingsCs,
        individualization: individualizationCs,
        customizer: customizerCs,
        orders: ordersCs,
        fulfillment: fulfillmentCs,
    },
    fr: {
        common: commonFr,
        nav: transNavFr,
        global: transGlobalFr,
        settings: settingsFr,
        individualization: individualizationFr,
        customizer: customizerFr,
        orders: ordersFr,
        fulfillment: fulfillmentFr,
    },
    nl: {
        common: commonNl,
        nav: transNavNl,
        global: transGlobalNl,
        settings: settingsNl,
        individualization: individualizationNl,
        customizer: customizerNl,
        orders: ordersNl,
        fulfillment: fulfillmentNl,
    },
}

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem('zr_customizer_language') ?? 'de',
        fallbackLng: 'en',
    })
    .then(() => {})

export default i18next
